import { RecoveryFlow } from "@ory/client-fetch";
import { Recovery as OryRecovery } from "@ory/elements-react/theme";
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { createSdkErrorHandler, oryConfig, sdk } from "./ory-sdk";

export const Recovery = () => {
  const [flow, setFlow] = useState<RecoveryFlow | null>(null);
  const [searchParams, setSearchParams] = useSearchParams();

  const navigate = useNavigate();

  const getFlow = useCallback(
    async (flowId: string) => {
      const flowData = await sdk.getRecoveryFlow({ id: flowId });
      setFlow(flowData);
    },
    [setFlow]
  );

  const sdkErrorHandler = createSdkErrorHandler(
    navigate,
    getFlow,
    setFlow,
    "/recovery",
    false
  );

  const createFlow = async () => {
    try {
      const flowData = await sdk.createBrowserRecoveryFlow();
      setSearchParams({ flow: flowData.id });
      setFlow(flowData);
    } catch (error) {
      await sdkErrorHandler(error);
    }
  };

  useEffect(() => {
    const flowId = searchParams.get("flow");
    if (flowId) {
      getFlow(flowId).catch(() => createFlow());
      return;
    }
    createFlow();
  }, []);

  if (!flow) {
    return (
      <div className="h-[576px] px-12 pt-12">Loading authorization...</div>
    );
  }

  return (
    <div className="py-0">
      <OryRecovery
        flow={flow}
        config={oryConfig}
        components={{
          Card: {
            Footer: () => (
              <div className="flex flex-col gap-2 text-sm mt-4">
                <button
                  type="button"
                  onClick={() => {
                    navigate({ pathname: "/login" }, { replace: true });
                  }}
                  className="text-primary hover:underline"
                >
                  Back to login
                </button>
              </div>
            ),
          },
        }}
      />
    </div>
  );
};
